/** Gaps larger than this are the on-screen keyboard, not browser chrome. */
const KEYBOARD_GAP_PX = 120;

/** Keep overlay sizing in step with the visible viewport (mobile browser chrome, keyboard). */
export function bindVisualViewportCss(target: HTMLElement = document.documentElement): () => void {
  const apply = () => {
    const viewport = window.visualViewport;
    if (!viewport) return;
    const height = Math.round(viewport.height);
    const offsetTop = Math.round(viewport.offsetTop);
    const bottomGap = Math.max(0, Math.round(window.innerHeight - offsetTop - height));
    target.style.setProperty('--visual-viewport-height', `${height}px`);
    target.style.setProperty('--visual-viewport-offset-top', `${offsetTop}px`);
    target.style.setProperty(
      '--visual-viewport-offset-bottom',
      bottomGap > KEYBOARD_GAP_PX ? `${bottomGap}px` : '0px',
    );
  };

  apply();
  const viewport = window.visualViewport;
  if (!viewport) return () => {};

  viewport.addEventListener('resize', apply);
  viewport.addEventListener('scroll', apply);
  return () => {
    viewport.removeEventListener('resize', apply);
    viewport.removeEventListener('scroll', apply);
  };
}
